import { useEffect, useState } from "react";

/**
 * The current time, refreshed every `intervalMs`, so time-based UI (e.g. an "Overdue" badge) updates on a page that
 * is left open. Queries don't refetch on window focus in this app, so nothing else would re-render it.
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
